import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Edit, Toolbar, useNotify, useRefresh } from "react-admin";
import { useTranslate } from "react-admin";

import { useErrorHandler } from "../hooks/useErrorHandler";
import { color } from "../theme/designTokens";
import { BaseModalProps } from "../types/modal";
import { CloseButton, SaveButton } from "./buttons";
import { LocationForm } from "./LocationForm";

const LocationEditToolbar = ({ onCancel }: { onCancel: () => void }) => {
  return (
    <Toolbar>
      <SaveButton />
      <CloseButton onClick={onCancel} />
    </Toolbar>
  );
};

const LocationEdit = ({ open, onClose }: BaseModalProps) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const handleError = useErrorHandler();
  const translate = useTranslate();

  const handleSuccess = () => {
    notify("edit.location.success", { type: "success" });
    refresh();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle sx={{ backgroundColor: color.background }}>{translate("edit.location.title")}</DialogTitle>
      <DialogContent>
        <Edit
          resource="Location"
          actions={false}
          mutationMode="optimistic"
          mutationOptions={{
            onError: error => handleError(error, translate("edit.location.error")),
            onSuccess: handleSuccess,
          }}
        >
          <LocationForm toolbar={<LocationEditToolbar onCancel={onClose} />} />
        </Edit>
      </DialogContent>
    </Dialog>
  );
};

export default LocationEdit;
